import React, { Suspense } from "react";
import { ToastProvider } from "@weezevent/nacre";
import Loader from "./components/ui/loader";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Authentication } from "./components/user/authentication";
import { PermissionsLayer } from "./components/user/permissions";
import { fetcher } from "@weezevent/core";
import { fetcher as core_fetcher } from "@weezevent/core/fetch";
import { InitializeFetch } from "initialize-fetch";
import OrganizationRouteur from "./components/routing/organization-routeur";
import NotFoundPage from "./pages/error/not-found-page";

export default function App() {
	React.useEffect(() => {
		const handle_401 = ({ text }) => {
			let expired_token = /Invalid token/;
			if (expired_token.test(text) || expired_token.test(text?.detail)) {
				// Force relogin
				return window.location.reload();
			}
		};
		fetcher.on("401", handle_401);
		core_fetcher.on("401", handle_401);
	}, []);

	return (
		<ToastProvider>
			<Suspense fallback={<Loader />}>
				<BrowserRouter>
					<Authentication config={window.weezConfig.connect}>
						<InitializeFetch>
							<PermissionsLayer>
								<Switch>
									<Route
										path="/access/O:organizationId(\d+)"
										component={OrganizationRouteur}
									/>
									<Route
										exact
										path="/access"
										render={() => {
											const adminUrl =
												window.weezConfig?.front
													?.weezeventAdminUrl;
											if (adminUrl) {
												window.location.replace(
													adminUrl
												);
											}
											return null;
										}}
									/>
									<Route
										exact
										path="/"
										render={() => {
											const adminUrl =
												window.weezConfig?.front
													?.weezeventAdminUrl;
											if (adminUrl) {
												window.location.replace(
													adminUrl
												);
											}
											return null;
										}}
									/>
									<Route
										render={() => (
											<NotFoundPage
												title="access.common.error.invalidOrganizationId"
												subTitle="access.common.error.invalidOrganizationIdSubtitle"
											/>
										)}
									/>
								</Switch>
							</PermissionsLayer>
						</InitializeFetch>
					</Authentication>
				</BrowserRouter>
			</Suspense>
		</ToastProvider>
	);
}
